import { render, staticRenderFns } from "./first-time-login-form.vue?vue&type=template&id=2870eceb&scoped=true"
import script from "./first-time-login-form.vue?vue&type=script&lang=js"
export * from "./first-time-login-form.vue?vue&type=script&lang=js"
import style0 from "./first-time-login-form.vue?vue&type=style&index=0&id=2870eceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870eceb",
  null
  
)

export default component.exports